module.exports = __webpack_public_path__ + "img/harmony_banner.b3b0beff.jpg";